import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { usePreferredBuilderSurface } from '../../../hooks/usePreferredBuilderSurface';
import { DesktopBuilder } from './DesktopBuilder';

const MobileBuilderShell = React.lazy(() => import('./mobile/MobileBuilderShell'));

export const SlideEditor: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const surface = usePreferredBuilderSurface();

  if (surface === 'mobile') {
    return (
      <Suspense
        fallback={
          <div className="h-screen flex items-center justify-center bg-neutral-950">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500" />
          </div>
        }
      >
        <MobileBuilderShell formId={id} />
      </Suspense>
    );
  }

  return <DesktopBuilder />;
};
